<script setup>
  import { onMounted } from 'vue';
  import { useFelixBagAuxStore } from '../../../store';

  const felixBagAuxStore = useFelixBagAuxStore();

  onMounted(() => {
    felixBagAuxStore.seekToAfter(265.7, 36000)
  });

</script>

<template>
  <div id="avaliacao-cuidados">
  </div>
</template>

<style>
#avaliacao-cuidados {}
</style>